<script>
    import Spinner from "../../spinner/Spinner.svelte";
    import FormErrors from "../../forms/FormErrors.svelte";
    import {apiFetch, apiPost} from '../../../apiFetch';
    import {createForm, Field} from "svelte-forms-lib";
    import {
        Button,
        Form,
        FormGroup,
        Input,
        Label,
    } from 'sveltestrap';
    import {goto} from "@sveltech/routify/runtime";
    import {_} from 'svelte-i18n';

    let submitting = false;
    let formError = null;
    export let event;
    export let completed;

    const {form, handleChange, handleSubmit} = createForm({
        initialValues: {
            minimum_age: event.minimum_age ? event.minimum_age : 18,
        },
        onSubmit: values => {
            submitting = true;
            const postData = {event_minimum_age: values};
            apiPost('/events/' + event.id, postData)
                    .then((result) => {
                        if (result.status !== 200) {
                            formError = result.errors;
                        } else {
                            completed();
                        }
                        submitting = false;
                    })
                    .catch((error) => {
                        alert(error);
                        submitting = false;
                    });
        }
    });

</script>

{#await apiFetch('/organizations')}
    <Spinner/>
{:then data}
    {#if submitting}
        <Spinner/>
    {/if}
    {#if formError}
        <FormErrors errors={formError}/>
    {/if}
    <Form on:submit={handleSubmit} class="content">
        <FormGroup>
            <Label for="minimum_age">Minimum age</Label>
            <Input
                    id="minimum_age"
                    name="minimum_age"
                    type="number"
                    on:change={handleChange}
                    bind:value={$form.minimum_age}
            />
        </FormGroup>

        <FormGroup>
            <Button type="submit" color="primary">{$_('global.save')}</Button>
        </FormGroup>

    </Form>
{:catch error}
    {@debug error}
    <p>An error occurred!</p>
{/await}